// User English translations
export const userEn = {
  'add.driver': 'Add Driver',
  'add.user': 'Add User',
  'are.you.sure.you.want.to.delete.this.user': 'Are you sure you want to delete this user?',
  'current.default.driver.salary.rate': 'Current Default Driver Salary Rate',
  'default.driver.salary.rate': 'Default Driver Salary Rate',
  'driver': 'Driver',
  'driver.created.successfully': 'Driver created successfully',
  'driver.deleted.successfully': 'Driver deleted successfully',
  'driver.details': 'Driver Details',
  'driver.management': 'Driver Management',
  'driver.name': 'Driver Name',
  'driver.phone': 'Driver Phone',
  'driver.salary': 'Driver Salary',
  'driver.updated.successfully': 'Driver updated successfully',
  'drivers': 'Drivers',
  'edit.driver': 'Edit Driver',
  'edit.user': 'Edit User',
  'error.creating.driver': 'Error creating driver',
  'error.deleting.driver': 'Error deleting driver',
  'error.fetching.drivers': 'Error fetching drivers',
  'error.updating.driver': 'Error updating driver',
  'failed.to.create.driver': 'Failed to create driver',
  'failed.to.delete.driver': 'Failed to delete driver',
  'failed.to.fetch.drivers': 'Failed to fetch drivers',
  'failed.to.update.driver': 'Failed to update driver',
  'role': 'Role',
  'salary.rate': 'Salary Rate',
  'total.drivers': 'Total Drivers',
  'update.driver.rate': 'Update Driver Rate',
  'user': 'User',
  'user.details': 'User Details',
  'user.management': 'User Management',
  'username': 'Username',
  'users': 'Users',
  'users.involved': 'Users Involved',
};
